import React from 'react';
import { ETAPAS_VENTAS } from '../../constants';
import { formatearEntreCalles } from '../../utils';

function VentasPanel({
  conversacionActiva,
  nombre,
  ventaActual,
  accionRapidaVentas,
  abrirModalVentas,
  confirmarVenta,
  isClosed,
}) {
  if (!ventaActual) {
    return (
      <div className="ctx-card">
        <div className="ctx-card-header"><span className="ctx-card-title">Pipeline de ventas</span></div>
        <div className="empty-note">Sin datos comerciales cargados todavía.</div>
      </div>
    );
  }

  const fmt = (value, fallback = '-') => {
    if (value === null || value === undefined) return fallback;
    const text = String(value).trim();
    return text || fallback;
  };

  const resumenVenta = ventaActual?.resumenInterno || {};
  const etapaActual = ventaActual?.etapa || 'Lead nuevo';
  const proximaAccion = ventaActual?.proximaAccion || 'Revisar resumen interno';
  const coberturaVenta = ventaActual?.cobertura || 'Pendiente de validar';
  const precioVenta = resumenVenta.precio ? `$${resumenVenta.precio}` : '-';

  const indiceActual = Math.max(ETAPAS_VENTAS.indexOf(etapaActual), 0);
  const progreso = Math.round(((indiceActual + 1) / ETAPAS_VENTAS.length) * 100);

  const SalesActions = () => {
    if (etapaActual === 'Lead nuevo') {
      return (
        <>
          <button className="sales-main-action" onClick={() => accionRapidaVentas('contactar')}>Marcar contacto</button>
          <button className="sales-secondary-action" onClick={() => accionRapidaVentas('calificar')}>Calificar lead</button>
        </>
      );
    }

    if (etapaActual === 'Contactado' || etapaActual === 'Calificado') {
      return (
        <>
          <button className="sales-main-action" onClick={() => accionRapidaVentas('cobertura')}>Validar cobertura</button>
          <button className="sales-secondary-action" onClick={() => accionRapidaVentas('seguimiento')}>Programar seguimiento</button>
          <button className="sales-danger-action" onClick={() => accionRapidaVentas('perdida')}>Marcar perdida</button>
        </>
      );
    }

    if (etapaActual === 'Cobertura validada') {
      return (
        <>
          <button className="sales-main-action" onClick={() => accionRapidaVentas('propuesta')}>Enviar propuesta</button>
          <button className="sales-secondary-action" onClick={() => accionRapidaVentas('seguimiento')}>Programar seguimiento</button>
          <button className="sales-danger-action" onClick={() => accionRapidaVentas('perdida')}>Marcar perdida</button>
        </>
      );
    }

    if (etapaActual === 'Propuesta enviada' || etapaActual === 'Seguimiento') {
      return (
        <>
          <button className="sales-main-action" onClick={() => accionRapidaVentas('aceptar')}>Registrar aceptación</button>
          <button className="sales-secondary-action" onClick={() => accionRapidaVentas('seguimiento')}>Programar seguimiento</button>
          <button className="sales-danger-action" onClick={() => accionRapidaVentas('perdida')}>Marcar perdida</button>
        </>
      );
    }

    if (etapaActual === 'Aceptó oferta') {
      return (
        <>
          <button className="sales-main-action" onClick={() => abrirModalVentas('confirmar')}>Revisar venta</button>
          <button className="sales-secondary-action" onClick={() => confirmarVenta()}>Confirmar venta</button>
          <button className="sales-danger-action" onClick={() => accionRapidaVentas('perdida')}>Marcar perdida</button>
        </>
      );
    }

    if (etapaActual === 'Venta confirmada') {
      return (
        <>
          <div className="sales-confirmed-note">Venta ya enviada a implementación</div>
          <button className="sales-main-action" onClick={() => abrirModalVentas('confirmar')}>Revisar venta</button>
        </>
      );
    }

    return (
      <>
        <button className="sales-main-action" onClick={() => abrirModalVentas('confirmar')}>Revisar venta</button>
        <button className="sales-secondary-action" onClick={() => accionRapidaVentas('seguimiento')}>Programar seguimiento</button>
      </>
    );
  };

  return (
    <>
      <details className="ctx-card sales-pipeline-accordion" open>
        <summary className="sales-pipeline-summary">
          <span className="ctx-card-title">Pipeline de ventas</span>
          <span className="sales-summary-right">
            <span className="status-badge" style={{ background: '#22c55e22', color: '#4ade80', fontSize: 11 }}>{etapaActual}</span>
            <span className="sales-chevron">⌄</span>
          </span>
        </summary>

        <div className="sales-pipeline-body">
          <div className="sales-progress-row">
            <div className="sales-progress-bar">
              <div className="sales-progress-fill" style={{ width: `${progreso}%` }} />
            </div>
            <span className="sales-progress-text">{progreso}%</span>
          </div>

          <div className="sales-pipeline-block">
            <span className="sales-mini-label">Estado actual</span>
            <div className="sales-current-stage">● {etapaActual}</div>
          </div>

          <div className="sales-pipeline-block">
            <span className="sales-mini-label">Próxima acción</span>
            <div className="sales-next-action">{proximaAccion}</div>
          </div>

          <div className="sales-pipeline-block">
            <span className="sales-mini-label">Etapas</span>
            <div className="sales-stage-vertical">
              {ETAPAS_VENTAS.map((etapa) => {
                const idx = ETAPAS_VENTAS.indexOf(etapa);
                const estadoPaso = idx < indiceActual ? 'done' : idx === indiceActual ? 'current' : 'pending';
                return (
                  <div key={etapa} className={`sales-stage-line ${estadoPaso}`}>
                    <span>{estadoPaso === 'done' ? '✓' : estadoPaso === 'current' ? '●' : '○'}</span>
                    <strong>{etapa}</strong>
                  </div>
                );
              })}
            </div>
          </div>

          {!isClosed && (
            <div className="sales-pipeline-block">
              <span className="sales-mini-label">Acciones sugeridas</span>
              <div className="sales-action-list"><SalesActions /></div>
            </div>
          )}
        </div>
      </details>

      <div className="ctx-card sales-summary-card">
        <div className="ctx-card-header"><span className="ctx-card-title">Resumen comercial</span></div>
        {conversacionActiva.derivada_ia && <div className="internal-badge">🤖 Lead derivado por IA</div>}
        <div className="ctx-details">
          <div className="ctx-row"><span className="ctx-label">Cobertura</span><span className="ctx-value">{coberturaVenta}</span></div>
          <div className="ctx-row"><span className="ctx-label">Próxima acción</span><span className="ctx-value">{proximaAccion}</span></div>
          <div className="ctx-row"><span className="ctx-label">Cliente</span><span className="ctx-value">{fmt(resumenVenta.nombre_apellido || nombre)}</span></div>
          <div className="ctx-row"><span className="ctx-label">CUIL</span><span className="ctx-value">{fmt(resumenVenta.cuil)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Mail</span><span className="ctx-value">{fmt(resumenVenta.email)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Dirección</span><span className="ctx-value">{fmt(resumenVenta.direccion)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Entre calles</span><span className="ctx-value">{formatearEntreCalles(resumenVenta.entre_calle_1, resumenVenta.entre_calle_2) || '-'}</span></div>
          <div className="ctx-row"><span className="ctx-label">Localidad</span><span className="ctx-value">{fmt(resumenVenta.localidad)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Plan</span><span className="ctx-value">{fmt(resumenVenta.plan || ventaActual.planSugerido)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Precio</span><span className="ctx-value">{precioVenta}</span></div>
          <div className="ctx-row"><span className="ctx-label">Medio de pago</span><span className="ctx-value">{fmt(resumenVenta.medio_pago)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Latitud</span><span className="ctx-value">{fmt(resumenVenta.latitud)}</span></div>
          <div className="ctx-row"><span className="ctx-label">Longitud</span><span className="ctx-value">{fmt(resumenVenta.longitud)}</span></div>
          {resumenVenta.mapa_url && (
            <div className="ctx-row"><span className="ctx-label">Mapa</span><a href={resumenVenta.mapa_url} target="_blank" rel="noreferrer" className="map-link">📍 Abrir ubicación</a></div>
          )}
        </div>
        {!isClosed && (
          <div className="sales-summary-actions">
            <button className="sales-main-action" onClick={() => abrirModalVentas('confirmar')}>Revisar venta</button>
            {ventaActual.etapa !== 'Venta confirmada' && (
              <button className="sales-secondary-action" onClick={() => confirmarVenta()}>Confirmar y enviar a implementación</button>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(VentasPanel);
